import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getPayrollSettings(token) {
  const res = await axios.get(`${API}/payroll/settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updatePayrollSettings(payload, token) {
  const res = await axios.put(`${API}/payroll/settings`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listRateLevels(rateType, token) {
  const params = {};
  if (rateType) params.rate_type = rateType;
  const res = await axios.get(`${API}/payroll/rate-levels`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createRateLevel(payload, token) {
  const res = await axios.post(`${API}/payroll/rate-levels`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateRateLevel(levelId, payload, token) {
  const res = await axios.put(`${API}/payroll/rate-levels/${levelId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteRateLevel(levelId, token) {
  const res = await axios.delete(`${API}/payroll/rate-levels/${levelId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateStaffPayProfile(staffId, payload, token) {
  const res = await axios.put(`${API}/payroll/staff/${staffId}/profile`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateStaffCommissionPlan(staffId, basis, payload, token) {
  const res = await axios.put(
    `${API}/payroll/staff/${staffId}/commission-plan/${basis}`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function previewPayroll(payload, token) {
  const res = await axios.post(`${API}/payroll/preview`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createPayrollRun(payload, token) {
  const res = await axios.post(`${API}/payroll/runs`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listPayrollRuns(token) {
  const res = await axios.get(`${API}/payroll/runs`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getPayrollRun(runId, token) {
  const res = await axios.get(`${API}/payroll/runs/${runId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deletePayrollRun(runId, token) {
  const res = await axios.delete(`${API}/payroll/runs/${runId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updatePayrollRunStaffPayout(runId, staffId, payload, token) {
  const res = await axios.put(
    `${API}/payroll/runs/${runId}/staff/${staffId}/payout`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function exportPayrollRunCsv(runId, token) {
  const res = await axios.get(`${API}/payroll/runs/${runId}/export`, {
    headers: authHeaders(token),
    responseType: "blob",
  });
  return res;
}
